// import { Modal } from 'bootstrap';
import { formatAsCurrency, formatNumCommas, finiteOrZero } from './utilities';
import { Calculator } from './calculator';
const calculatorcont = document.querySelector('#medOneCalc');
const calculatorForm = calculatorcont.querySelector('#calculatorForm');
const allInputs = calculatorForm.querySelectorAll('input');
const totalHoursDisp = calculatorcont.querySelector('#hoursSavedTotal');
const inlineHrsTotal = calculatorcont.querySelector('#inlineHrsTotal');
const incRevOppDisp = calculatorcont.querySelector('#incRevOppDisp');
const annualRevOpp = calculatorcont.querySelector('#annualRevOpp');
const additionalPatientPercentDisplay = calculatorcont.querySelector(
  '#additionalPatientPercentDisplay'
);
const additionalHoursPercent = calculatorcont.querySelector(
  '#additionalHoursPercent'
);
const addPatientsSeen = calculatorcont.querySelector('#addPatientsSeen');
const personalHoursMonthly = calculatorcont.querySelector('#personalHoursMonthly');
// declare a new calculator
const dragonCalculator = new Calculator();
const {
  getHoursSavedPerMonth,
  getMonthlyRevOpportunity,
  getAdditionalPatientThroughput,
  getHoursForPersonalTime,
  getAnnualRevOpportunity,
  formValues,
} = dragonCalculator;


// ***** Functions that update page elements *****
// Update summary section
const updateTotals = () => {
  dragonCalculator.getFormValues(allInputs);
  totalHoursDisp.textContent = Math.round(getHoursSavedPerMonth());
  inlineHrsTotal.textContent = Math.round(getHoursSavedPerMonth());
  incRevOppDisp.textContent = formatAsCurrency(getMonthlyRevOpportunity());
  annualRevOpp.textContent = formatAsCurrency(getAnnualRevOpportunity());
  additionalPatientPercentDisplay.textContent = formValues.additionalHoursPercent;
  addPatientsSeen.textContent = getAdditionalPatientThroughput();
  personalHoursMonthly.textContent = Math.round(getHoursForPersonalTime());
};

// ***** Event Handler Functions *****
const formChangeHandler = (e) => {
  e.stopPropagation();
  dragonCalculator.updateFormValues(e.target.id, e.target.value);
  updateTotals();
};

const sliderChangeHandler = (e) => {
  e.stopPropagation();
  dragonCalculator.updateFormValues(e.target.id, e.target.value);
  updateTotals();
};
additionalHoursPercent.addEventListener('input', sliderChangeHandler, false );
// ***** Event listeners *****
calculatorForm.addEventListener('input', formChangeHandler, false);

// ***** Functions Fired On Page Load *****
dragonCalculator.getFormValues(allInputs);
dragonCalculator.updateFormValues(
  additionalHoursPercent.id,
  additionalHoursPercent.value
);
updateTotals();
